var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2075 2499.9",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2016.6V496.8L1344.4 0 2075 233.7v2045.9l-730.6 220.3L0 2016.6l1344.4 161.8V409.2L467.6 613.8v1198.3z",
    fill: "#eb3c00"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDc1IDI0OTkuOSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlYjNjMDA7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAsMjAxNi42VjQ5Ni44TDEzNDQuNCwwLDIwNzUsMjMzLjdWMjI3OS42bC03MzAuNiwyMjAuM0wwLDIwMTYuNmwxMzQ0LjQsMTYxLjhWNDA5LjJMNDY3LjYsNjEzLjhWMTgxMi4xWiIvPjwvc3ZnPg==";
export { SvgOffice as ReactComponent };